const doesUserExist = () => {
  return localStorage.getItem('tsUserInfo') ? true : false
}

const getUserImage = () => {
  const user = JSON.parse(localStorage.getItem('tsUserInfo'));
  if (user)
    return user.userInfo.profilePic ? user.userInfo.profilePic.uri : "/icons/user.png"
  else
    return "/icons/user.png";
}

const getUserDisplayName = () => {
  const user = JSON.parse(localStorage.getItem('tsUserInfo'));
  if (user)
    return user.userInfo ? user.userInfo.displayName : (user.displayName ? user.displayName : user.preferred_username);
  else
    return "";
}

const getUserID = () => {
  const user = JSON.parse(localStorage.getItem('tsUserInfo'));
  if (user)
    return user.userInfo ? user.userInfo.id : null
  else
    return "";
}

const getUserProfile = () => {
  const user = JSON.parse(localStorage.getItem('tsUserInfo'));
  if (user)
    return user.userInfo ? user.userInfo : {}
  else
    return {};

}
const isContributor = () => {
  const user = JSON.parse(localStorage.getItem('tsUserInfo'));
  if (user) {
    if (user.realm_access.roles.indexOf("role_author") !== -1) {
      return true;
    } else {
      return false;
    }
  }
  else
    return null;
}
const roleCheck = (userObj) => {
  const user = JSON.parse(localStorage.getItem('tsUserInfo'));
  const roleMappingJson = {
    "contributor": "role_author",
    "user": "role_user",
    "admin": "role_admin"
  };
  if (user) {
    if (userObj.roleProps.accessTo) {
      for (let index = 0; index < userObj.roleProps.accessTo.length; index++) {
        if (user.realm_access.roles.indexOf(roleMappingJson[userObj.roleProps.accessTo[index]]) !== -1) {
          return true;
        }
      }
    } else {
      return true;
    }
  }
  return false;
}
const doesUserHaveRole = (roleName) => {
  const user = JSON.parse(localStorage.getItem('tsUserInfo'));
  const roleMappingJson = {
    "contributor": "role_author",
    "user": "role_user",
    "admin": "role_admin"
  };
  if (user) {
    if (user.realm_access.roles.indexOf(roleMappingJson[roleName]) !== -1) {
      return true;
    } else {
      return false;
    }
  }
  return false;
}

export default {
  getUserDisplayName,
  doesUserExist,
  getUserImage,
  getUserProfile,
  getUserID,
  isContributor,
  roleCheck,
  doesUserHaveRole
};
